export default {
  nome: {
    value: null
  }
  // },
  // gedTipoID: {
  //   value: null,
  //   options: []
  // },
  // gedAssuntoID: {
  //   value: null,
  //   options: []
  // },
  // gedTagID: {
  //   selectedTags: [],
  //   options: []
  // }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/documents/components/search/search-form.js